module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chat-red-b1e5f63774cecbd30a9d73c1f72cbc87.svg";